import { Link } from "react-router-dom";

/** deckloom.net is the platform (API and player); the page is three lines: the name, how to reach us, the small print. */
export function HomePage() {
  return (
    <main className="center home">
      <div className="lines">
        <span className="name">deckloom</span>
        <Footer />
      </div>
    </main>
  );
}

/** The foot of the home page and the text pages: how to reach us, and where the small print is. */
export function Footer() {
  return (
    <footer className="foot">
      <a href="mailto:info@deckloom.net">info@deckloom.net</a>
      <nav>
        <Link to="/about">about</Link>
        <span className="sep">·</span>
        <Link to="/privacy">privacy policy</Link>
        <span className="sep">·</span>
        <Link to="/terms">terms of service</Link>
      </nav>
    </footer>
  );
}
